export const EstimatorTemplate = {
    getFormName() {
        return {


            ConceptualEstimate: "",
            FSA: "",
            HardBid: "",
            ChangeOrders: "",
            Selections: "",
            Total: "",
            ProjectManager: "",
            InteriorDesigner: "",
            VPComments: "",
            projectId: 0,
            actual_start_month: 0,

            section_2: [
                {
                    Financials: "PM PSA (0200)",
                    Budget: "",
                    AmountUsed: "",
                    BudgetRemaining: "",
                    EstimatedHoursToComplete: "",
                    ChargeOutRate: "",
                    ProjectedBudgetToComplete: "",
                    OverUnderBudget: "",
                    VPComments: ""
                },
                {
                    Financials: "EST PSA (0205)",
                    Budget: "",
                    AmountUsed: "",
                    BudgetRemaining: "",
                    EstimatedHoursToComplete: "",
                    ChargeOutRate: "",
                    ProjectedBudgetToComplete: "",
                    OverUnderBudget: ""
                },
                {
                    Financials: "Design INT PSA (0220)",
                    Budget: "",
                    AmountUsed: "",
                    BudgetRemaining: "",
                    EstimatedHoursToComplete: "",
                    ChargeOutRate: "",
                    ProjectedBudgetToComplete: "",
                    OverUnderBudget: ""
                },
                {
                    Financials: "Design Supp PSA (0240)",
                    Budget: "",
                    AmountUsed: "",
                    BudgetRemaining: "",
                    EstimatedHoursToComplete: "",
                    ChargeOutRate: "",
                    ProjectedBudgetToComplete: "",
                    OverUnderBudget: ""
                },
                {
                    Financials: "PSA Budget on track (0205)",
                    Budget: "",
                    AmountUsed: "",
                    BudgetRemaining: "",
                    EstimatedHoursToComplete: "",
                    ChargeOutRate: "",
                    ProjectedBudgetToComplete: "",
                    OverUnderBudget: ""
                },
                {
                    Financials: "Specs & Bidding Budget on track (0360)",
                    Budget: "",
                    AmountUsed: "",
                    BudgetRemaining: "",
                    EstimatedHoursToComplete: "",
                    ChargeOutRate: "",
                    ProjectedBudgetToComplete: "",
                    OverUnderBudget: ""
                },
            ],


            dear: "",
            dearVPCComments: "",
            hereIsYourWeeklySummaryFrom: "",
            hereIsYourWeeklySummaryTo: "",
            hereIsYourWeeklySummaryVPCComments: "",
            projectSummary: "",
            no_of_month: "",
            projectSummaryVPCComments: "",
            scheduleConstructionStartDate: "",
            scheduleProjectCompletion: "",
            scheduleVPCComments: "",
            vpConstructionCommentsForAll: "",
            totalSqFt: "",

            section_4: [
                {
                    preConstructionShedule: 'FSA signed',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Date FSA was signed',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Agent Authorization',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Date Agent Authorization sent to municaplity (within 1 week of signing FSA)',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Site Measure Plan',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Date site measure arranged for (within 2 weeks of signing FSA)	',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Site Survey Plan',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Estimated time frame for site survey (within 3 weeks of signing FSA)	',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Building Plans Started',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Estimated time frame for plans to start (within 4 weeks of signing FSA)	',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Building Plans Approved',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Estimated time frame for plans to be approved (within 2 months of building plans starting)	',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Building Plans Sent to Engineer',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Estimated time frame for plans to be sent out to structural engineer (within 1 week of receiving approved building plans)	',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'ROM Started',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Estimated time frame for rough order of magnitude estimate to be started (within 1 week of receiving approved building plans)	',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Contract & ROM Approved',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Estimated time frame for rough order of magnitude estimate to be reviewed and approved by client (Within 3 weeks of ROM starting)',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Building Permit Application Submitted',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Estimated time frame for permit submission (Within 1 week of contract & ROM approval)',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Project Specifications built and Bids send out to Trade Partners',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Estimated time frame for specifications to be sent out for bidding (Within 2 weeks of contract & ROM approval)	',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Bids Estimate Approved',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Estimated time frame for bid estimate to be approved (Within 1 month of project specifications built and bids sent out to trade partners)	',
                    Notes: '',
                    VPComments: '',
                },
                {
                    preConstructionShedule: 'Building Permit Received',
                    PlannedCompletionDate: '',
                    CurrentForecastCompletionDate: '',
                    ActualCompletionDate: '',
                    Description: 'Estimated time for permit approval (Approx 2 months from permit application, dependent on municipality)	',
                    Notes: '',
                    VPComments: '',
                },
            ],

            section_5: [
                {
                    ProjectBudget: "FSA Budget",
                    Amount: "",
                    PreConstManagerComments: "",
                    VPComments: "",
                },
                {
                    ProjectBudget: "CWO Totals",
                    Amount: "",
                    PreConstManagerComments: "",
                    VPComments: "",
                },
                {
                    ProjectBudget: "Total FSA Budget",
                    Amount: "",
                    PreConstManagerComments: "",
                    VPComments: "",
                },
                {
                    ProjectBudget: "Total Cost Used",
                    Amount: "",
                    PreConstManagerComments: "",
                    VPComments: "",
                },
                {
                    ProjectBudget: "FSA Running Total",
                    Amount: "",
                    PreConstManagerComments: "",
                    VPComments: "",
                },

            ],
            section_6: [
                {
                    ActionItems: "",
                    VPComments: "",
                },
            ],
            section_7: [
                {
                    Title: "All PO's Issued - 1 week after bid estimate is signed",
                    PlannedCompletionDate: "",
                    CurrentForecastCompletionDate: "",
                    ActualCompletionDate: "",
                    Done: "",
                    PreConstManagerComments: "",
                    VPComments: "",
                },
                {
                    Title: "Trades added into BT - 1 week after bid estimate is signed",
                    PlannedCompletionDate: "",
                    CurrentForecastCompletionDate: "",
                    ActualCompletionDate: "",
                    Done: "",
                    PreConstManagerComments: "",
                    VPComments: "",
                },
                {
                    Title: "Project Plan Complete - 2 weeks after bid estimate is signed",
                    PlannedCompletionDate: "",
                    CurrentForecastCompletionDate: "",
                    ActualCompletionDate: "",
                    Done: "",
                    PreConstManagerComments: "",
                    VPComments: "",
                },
                {
                    Title: "Project turnover meeting with PM - 2 weeks after bid estimate is signed",
                    PlannedCompletionDate: "",
                    CurrentForecastCompletionDate: "",
                    ActualCompletionDate: "",
                    Done: "",
                    PreConstManagerComments: "",
                    VPComments: "",
                },
                {
                    Title: "Project Binder for PM Complete - 2 weeks after bid estimate is signed - CONFIRM WITH PM IF THEY WANT A BINDER",
                    PlannedCompletionDate: "",
                    CurrentForecastCompletionDate: "",
                    ActualCompletionDate: "",
                    Done: "",
                    PreConstManagerComments: "",
                    VPComments: "",
                },

            ],
            // section_7: [
            //     {
            //         Title: "ROM Completed - 2 weeks from received confirmed plans",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "Client Approves Proposal/Signs Contract",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "Project Created in BuilderTrend",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "Bids Sent Out - 1 week after signing contract",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "Project turnover meeting with PM",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "Project Plan Complete - 2 weeks after signing contract",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "Bids Received - 4 weeks after signing contract",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "Bid estimate Approved by Client - 5 weeks after signing contract",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "All PO's Issued - 1 week after bid estimate is signed",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "Trades Entered into BT - 1 week after bid estimate is signed",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "Project Binder for PM Complete - 2 weeks after bid estimate is signed",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            //     {
            //         Title: "Risk/Safety/Client/Team/Other",
            //         PlannedCompletionDate: "",
            //         CurrentForecastCompletionDate: "",
            //         ActualCompletionDate: "",
            //         Done: "",
            //         PreConstManagerComments: "",
            //         VPComments: "",
            //     },
            // ],

        }
    },

    section_2_List() { return ["PM PSA (0200)", "EST PSA (0205)", "Design INT PSA (0220)", "Design Supp PSA (0240)", "PSA Budget on track (0205)", "Specs & Bidding Budget on track (0360)",] },

    section_3_List() { return ["dear", "dearVPCComments", "vpConstructionCommentsForAll", "hereIsYourWeeklySummaryFrom", "hereIsYourWeeklySummaryTo", "hereIsYourWeeklySummaryVPCComments", "projectSummary", "projectSummaryVPCComments", "scheduleConstructionStartDate", "scheduleProjectCompletion", "scheduleVPCComments",] },

    section_4_List() { return ["FSA signed", "Agent Authorization", "Site Measure Plan", "Site Survey Plan", "Building Plans Started", "Building Plans Approved", "Building Plans Sent to Engineer", "ROM Started", "Contract & ROM Approved", "Building Permit Application Submitted", "Project Specifications built and Bids send out to Trade Partners", "Bids Estimate Approved", "Building Permit Received",] },
    // section_5_List() { return ["ProjectBudget", "Amount", "PreConstManagerComments", "VPComments",] },

    section_5_List() { return ["FSA Budget - Lida internal labour", "Total Cost Used", "FSA Remaining Total", "Third Party Invoices (If required) "] },


    section_6_List() { return ["Sent follow up to see where Josh is at 01/12/", "",] },

    section_7_List() { return ["All PO's Issued - 1 week after bid estimate is signed", "Trades added into BT - 1 week after bid estimate is signed", "Project Plan Complete - 2 weeks after bid estimate is signed", "Project turnover meeting with PM - 2 weeks after bid estimate is signed", "Project turnover meeting with PM ", "Project Plan Complete - 2 weeks after signing contract", "Bids Received - 4 weeks after signing contract", "Project Binder for PM Complete - 2 weeks after bid estimate is signed - CONFIRM WITH PM IF THEY WANT A BINDER",] },
    // section_7_List() { return ["ROM - 2 weeks from received confirmed plans ", "Client Approves Proposal/Signs Contract ", "Project Created in BuilderTrend", "Bids Sent Out - 1 week after signing contract", "Project turnover meeting with PM ", "Project Plan Complete - 2 weeks after signing contract", "Bids Received - 4 weeks after signing contract", "Bid estimate Approved by Client - 5 weeks after signing contract","All PO's Issued - 1 week after bid estimate is signed","Trades Entered into BT - 1 week after bid estimate is signed","Project Binder for PM Complete - 2 weeks after bid estimate is signed","Risk/Safety/Client/Team/Other?",] },


    getFormWarranty() {
        return {
            warranty :[
                {
                    followup:'3 Month follow up Phone call',
                    reminder:'',
                    followUpDate:'',
                    warranty:'',
                    tradePartner:'Site visit required?',
                    whoPays:'',
                    issue:'',
                },
                {
                    followup:'6 Month follow up Phone call',
                    reminder:'',
                    followUpDate:'',
                    warranty:'',
                    tradePartner:'Site visit required?',
                    whoPays:'',
                    issue:'',
                },
                {
                    followup:'12 Month follow up Phone call',
                    reminder:'',
                    followUpDate:'',
                    warranty:'',
                    tradePartner:'Site visit required?',
                    whoPays:'',
                    issue:'',
                },
                {
                    followup:'2 Year follow up Phone call',
                    reminder:'',
                    followUpDate:'',
                    warranty:'',
                    tradePartner:'Site visit required?',
                    whoPays:'',
                    issue:'',
                },
                {
                    followup:'Pre occupancy list',
                    reminder:'',
                    followUpDate:'',
                    warranty:'Deficiency/Touch Ups',
                    tradePartner:'Yes',
                    whoPays:'Trade Partner/Lida',
                    issue:'',
                },
                {
                    followup:'',
                    reminder:'',
                    followUpDate:'',
                    warranty:'warranty',
                    tradePartner:'',
                    whoPays:'Trade Partner',
                    issue:'',
                },
            ],
            projectId: 0,
            VPComments: '',
        }
           

    },


}
